const block = document.querySelector('.block-hero-display-new');
const imageContainer = document.querySelector('.block-hero-display-new__images');
const images = document.querySelectorAll('.block-hero-display-new__images img');
const rotatingHeading = document.querySelector('.block-hero-display-new__content .rotating-heading');
const headingSpans = document.querySelectorAll('.block-hero-display-new__content .rotating-heading span');
let rotatingHeadingHeight = 0;
let sliderInterval = null;
const slideCount = block?.getAttribute('data-slide-count') || 0;
let currentIndex = 0;
const slideDuration = 5000;
const imageTransitionDuration = parseFloat(
    getComputedStyle(images[0]).transitionDuration
) * 1000 || 1000;

const heroDisplayNew = {
    init() {
        this.animateBlock();
        this.setRotatingHeadingHeight();
    },

    animateBlock() {
        // Block animates in with css over 1.5s
        block.classList.add('block-animate-in');

         // Animate border over 2s
        this.animateImageBorder();

        // Start slider once initial animations are complete
        setTimeout(() => {
            this.setSliderInterval();
        }, 2000);
    },

    animateImageBorder() {
        imageContainer.classList.add('border-animate-in');
    },

    setRotatingHeadingHeight(onResize = false) {
        if (onResize) {
            rotatingHeadingHeight = 0;
        }

        if (headingSpans.length) {
            rotatingHeadingHeight = headingSpans[currentIndex].offsetHeight;

            rotatingHeading.style.setProperty('--rotating-heading-height', `${rotatingHeadingHeight}px`);
        }
    },

    setSliderInterval() {
        clearInterval(sliderInterval);

        sliderInterval = setInterval(() => {
            const nextIndex = ( currentIndex < slideCount - 1 ) ? currentIndex + 1 : 0;
            // Get the computed transition duration to avoid hardcoding delays

            // Heading span cross-fade
            headingSpans[currentIndex].classList.remove('active');
            headingSpans[nextIndex].classList.add('active');

            // Change heading span height
            rotatingHeading.style.setProperty('--rotating-heading-height', `${headingSpans[nextIndex].offsetHeight}px`);

            // Image fade
            images[nextIndex].classList.add('animate-in');
            // After the css transition completes, remove the active class from the now previous index, and update the new active index classes
            setTimeout(() => {
                images[currentIndex].classList.remove('active');
                images[nextIndex].classList.replace('animate-in', 'active');

                currentIndex = nextIndex;
            }, imageTransitionDuration);
        }, slideDuration);
    }
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
        heroDisplayNew.init();
    },
	loaded() {},
	resized() {
        heroDisplayNew.setRotatingHeadingHeight(true);
    },
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;